import { YesObject } from '@yes.technology/react-toolkit'
import { useParams } from 'react-router-dom'
import { SitemodelUuid } from 'sitemodel/shared/types'
import useYesObject from 'yesObject/shared/hooks/useYesObject'

interface SitemodelObjectState {
  sitemodel: YesObject | undefined
  isLoading: boolean
  isFetched: boolean
  refetchSitemodelFromUrl: () => void
}

interface UseSitemodelFromUrlProps {
  enabled?: boolean | undefined
}

export default function useSitemodelFromUrl({
  enabled = true
}: UseSitemodelFromUrlProps): SitemodelObjectState {
  const { sitemodelUuid: sitemodelUuidInUrl } = useParams<SitemodelUuid>()

  const isSidInUrl = Boolean(
    sitemodelUuidInUrl && !sitemodelUuidInUrl.includes('-')
  )

  const {
    yesObject: sitemodelFromUrl,
    isLoading: isLoadingSitemodelFromUrl,
    isFetched: isSiteModelFetched,
    fetchObjects: refetchSitemodelFromUrl
  } = useYesObject({
    objectUUID: isSidInUrl || !sitemodelUuidInUrl ? '' : sitemodelUuidInUrl,
    objectSID: isSidInUrl ? sitemodelUuidInUrl : '',
    objectclassUUID: globalThis.idObjectclassSitemodel,
    showLoading: true,
    displayMessageOnNoItemsFound: false,
    hasActiveSituation: true,
    enabled
  })

  return {
    sitemodel: sitemodelFromUrl,
    isLoading: isLoadingSitemodelFromUrl,
    isFetched: isSiteModelFetched,
    refetchSitemodelFromUrl
  }
}
